import React from 'react';
import { Container, Typography, TextField, Button } from '@mui/material';

const ContactUs = () => {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>Contact Us</Typography>
      <Typography variant="body1">We'd love to hear from you! Fill out the form below:</Typography>
      <form style={{ marginTop: '20px' }}>
        <TextField fullWidth label="Your Name" variant="outlined" margin="normal" />
        <TextField fullWidth label="Your Email" variant="outlined" margin="normal" />
        <TextField
          fullWidth
          label="Your Message"
          variant="outlined"
          margin="normal"
          multiline
          rows={4}
        />
        <Button variant="contained" color="primary" style={{ marginTop: '20px' }}>
          Submit
        </Button>
      </form>
    </Container>
  );
};

export default ContactUs;
